import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Ring, SeverityBadge, StatusBadge } from "@/components/Primitives";
import { Sparkles } from "lucide-react";

export default function Compliance() {
  const [scores, setScores] = useState([]);
  const [findings, setFindings] = useState([]);
  const [ai, setAI] = useState("");
  const [loadingAI, setLoadingAI] = useState(false);
  useEffect(() => {
    api.get("/compliance/scores").then(r => setScores(r.data));
    api.get("/compliance/findings").then(r => setFindings(r.data));
  }, []);
  const recommend = async () => {
    setLoadingAI(true);
    try { const r = await api.post("/ai/compliance-recommendations"); setAI(r.data.recommendations); } finally { setLoadingAI(false); }
  };
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Compliance Engine</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Framework Posture</h1>
        </div>
        <button onClick={recommend} data-testid="ai-compliance-btn" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-2"><Sparkles size={14}/>{loadingAI?"Generating…":"AI Recommendations"}</button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 bg-zinc-950 border border-zinc-900 rounded-md p-6">
        {scores.map(s => (
          <div key={s.framework_id} className="flex flex-col items-center" data-testid={`compliance-ring-${s.framework_id}`}>
            <Ring value={s.score} label={s.name} />
            <div className="text-[10px] text-zinc-500 font-mono mt-1">{s.resolved}/{s.total_findings || 0}</div>
          </div>
        ))}
      </div>

      {ai && <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5"><div className="font-display font-medium mb-2">AI Recommendations</div><pre className="text-xs whitespace-pre-wrap text-zinc-300 leading-relaxed" data-testid="compliance-ai-output">{ai}</pre></div>}

      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <div className="px-5 py-3 border-b border-zinc-900 font-display font-medium">Findings ({findings.length})</div>
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-2">Control</th><th className="text-left px-4 py-2">Title</th><th className="text-left px-4 py-2">Severity</th><th className="text-left px-4 py-2">Status</th><th className="text-left px-4 py-2">Created</th></tr></thead>
          <tbody>
            {findings.map(f => (
              <tr key={f.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{f.control}</td>
                <td className="px-4 py-2">{f.title}</td>
                <td className="px-4 py-2"><SeverityBadge level={f.severity}/></td>
                <td className="px-4 py-2"><StatusBadge status={f.status}/></td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{f.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
